<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-15 20:03:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-04 09:13:38
--> 
<template>
  <div class="textareabox">
    <v-menu offset-y
            :disabled='readonly'
            v-model="isShow"
            :close-on-content-click='false'>
      <template v-slot:activator="{ on, attrs }">
        <div>
          <v-textarea v-if="!isShow"
                      v-model="defaultcontent.content"
                      :background-color="!readonly?'rgb(2242, 242, 242)':'#fff'"
                      rows="10"
                      v-bind="attrs"
                      v-on="on"
                      :readonly='true'
                      :label="label || $t('label_The_mail_text')"
                      append-icon="mdi-longitude"></v-textarea>
        </div>
      </template>
      <v-list class="bigbox">
        <div class="pl-4"
             style="font-family:var(--body-font-family);color: #0F46C1;font-style: normal;font-weight: 500;font-size: 13px;">
          {{$t('label_The_mail_text')}}
        </div>
        <v-list-item v-for="(item, index) in childrencontent"
                     :key="index">
          <v-textarea v-model="item.content"
                      @blur="handleinputBlur"
                      :readonly='readonly'
                      background-color="rgb(2242, 242, 242)"
                      :rules='rules'
                      @change="change"
                      rows="5"
                      :label="item.language_code+'*'"></v-textarea>
          <propertyDialog :readonly='!readonly'
                          :function_uuid='function_uuid'
                          @getpropertylist='getpropertylist($event,index)'></propertyDialog>
        </v-list-item>
        <div v-show="!readonly"
             class="btnbox">
          <mrc_ess_submitBtn @cancel='cancel'
                             @success='success'
                             cancelText='cancel'
                             successText='OK'></mrc_ess_submitBtn>
        </div>
      </v-list>
    </v-menu>
  </div>
</template> 

<script>
import propertyDialog from './propertyDialog'
export default {
  components: {
    propertyDialog
  },
  props: {
    label: {
      type: String
    },
    // defaultcontent: {
    //   type: String,
    //   default: '请设置内容'
    // },
    content: {  //国际化字段
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    function_uuid: {
      type: String
    },
  },
  model: {
    prop: 'content',
    event: 'contentChange'
  },
  data () {
    return {
      rules: [
        value => !!value || 'Required.',
      ],
      showMenu: false,
      childrencontent: [],
      blurIndex: '',
      isShow: false
    };
  },
  computed: {
    defaultcontent () {
      let obj = {
        "language_code": this.$store.state.lang,    //国际化代码
        "content_type": "2",    //国际化字段(1:邮件主题  2:邮件内容)
        "content": ''
      }
      this.childrencontent.map(item => {
        if (item.language_code.toLowerCase() == this.$store.state.lang.toLowerCase()) {
          obj = {
            "language_code": item.value,    //国际化代码
            "content_type": "2",    //国际化字段(1:邮件主题  2:邮件内容)
            "content": item.content
          }
        }
      })
      return obj
    }
  },
  created () { },
  watch: {
    content: {
      handler (v) {
        this.childrencontent = this.$clone(v)
      }, deep: true
    }
  },
  mounted () {
    if (this.$store.state.uuid) {
      this.childrencontent = this.$clone(this.content)
    }
    else {
      if (this.$store.state.currentCompanyLanguage && !this.$store.state.currentCompanyLanguage.length > 0) return
      let arr = []
      this.$store.state.currentCompanyLanguage.map(item => {
        arr.push({
          "language_code": item.value,    //国际化代码
          "content_type": "2",    //国际化字段(1:邮件主题  2:邮件内容)
          "content": ''
        })
      })
      this.childrencontent = this.$clone(arr)
    }
  },

  methods: {
    change (val) {
      // console.log(val);
    },
    success () {
      this.isShow = false
      this.$emit('contentChange', this.childrencontent)
    },
    cancel () {
      this.isShow = false
      this.childrencontent = this.$clone(this.content)
    },
    getpropertylist (v, index) {
      v.map(item1 => {
        this.childrencontent[index].content ? this.childrencontent[index].content = this.childrencontent[index].content.slice(0, this.blurIndex) + item1.property + this.childrencontent[index].content.slice(this.blurIndex) : this.childrencontent[index].content = item1.property
      })
      // this.$set(this.childrencontent, index, item)
    },
    handleinputBlur (e) {
      this.blurIndex = e.srcElement.selectionStart
      // let dd = e.srcElement.selectionEnd
      // console.log(this.blurIndex, dd);
    }
  },
};
</script>

<style scoped>
.bigbox {
  padding: 0;
}
.btnbox /deep/ .btnGroup {
  justify-content: initial;
  flex-direction: row-reverse;
  padding-right: 35px;
}
.bigbox /deep/ .v-list-item {
  display: block;
}
.bigbox /deep/ .v-.v-messages {
  min-height: 0px;
}
</style>
